
// 获取utc+8时间戳
export function getUTCTime () {
  var currentTime = new Date(); // 创建一个表示当前时间的Date对象
  currentTime.setHours(currentTime.getUTCHours() + 8); // 将当前时间转换为UTC格式并加上8小时
  return currentTime.getTime();
}

// 时间处理 传入秒
export function getDateDiff (seconds) {
  if (seconds) {
    var days = Math.floor(seconds / (24 * 3600)); // 计算天数
    seconds %= (24 * 3600); // 剩余秒数
    var hours = Math.floor(seconds / 3600); // 计算小时
    seconds %= 3600; // 剩余秒数
    var minutes = Math.floor(seconds / 60); // 计算分钟
    seconds %= 60; // 剩余秒数
    if (days != 0) {
      return days + "day " + hours + "h " + minutes + "min " + seconds + "s";
    }
    if (hours != 0) {
      return hours + "h" + minutes + "min " + seconds + "s";
    }
    if (minutes != 0) {
      return minutes + "min " + seconds + "s";
    }
    if (seconds != 0) {
      return seconds + "s";
    }
  } else {
    return 0
  }
}

export function setTitleIcon () {
  var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
  link.href = '/goparty.png'; // 图片放public目录
  document.getElementsByTagName('head')[0].appendChild(link);
}
